module.exports = __webpack_public_path__ + "media/images/emblems/wappenwalchwil-4ae16516084548c22604520f39f77df1.png";